module.exports = __webpack_public_path__ + "img/sentinel-small-light.53b61287.svg";